import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdClose, MdSearch, MdFileDownload } from "react-icons/md";
import { Timestamp } from "firebase/firestore";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { TbReport, TbReportAnalytics } from "react-icons/tb";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Pos_receipt_summary() {
    const [isLoading, setIsLoading] = useState(false);
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    const servicetablename = "accountingfinancedb";
    const [select_company_uid, setSelect_company_uid] = useState(null);

    // State for voucher summary
    const [voucherSummary, setVoucherSummary] = useState([]);
    const [showVoucherDetails, setShowVoucherDetails] = useState(false);
    const [summarysearch, setSummarysearch] = useState(false);

    // State for totals
    const [totalCredit, setTotalCredit] = useState(0);
    const [totalDebit, setTotalDebit] = useState(0);
    const [printpage, setPrintpage] = useState("receipts");
    //download data
    const [printdata, setPrintdata] = useState([]);
    const [printapply, setPrintapply] = useState("");
    const [printid, setPrintid] = useState("");

    const [amount, setAmount] = useState(0);
    const [transaction, setTransaction] = useState(0);
    const [voucherselected, setVoucherselected] = useState("All Receipts");
    const [reportsrata, setReportsData] = useState([]);
    const [guid, setGuid] = useState(null);

    useEffect(() => {
        setGuid(Cookies.get("guid"));
    }, []);
    useEffect(() => {
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    // Set default date range to current month
    useEffect(() => {
        const today = new Date();
        const firstDay =
            today.getFullYear() +
            "-" +
            String(today.getMonth() + 1).padStart(2, "0") +
            "-01";
        const currentDay = today.toISOString().slice(0, 10);
        setFrom_date(firstDay);
        setTo_date(currentDay);
    }, []);

    const get_voucher_summary = async () => {
        if (!select_company_uid || !from_date || !to_date) {
            Toastshow("Please select date range", "warning");
            return;
        }

        setIsLoading(true);
        setSummarysearch(true);

        try {
            const startTimestamp = Timestamp.fromDate(new Date(`${from_date}T00:00:00`));
            const endTimestamp = Timestamp.fromDate(new Date(`${to_date}T23:59:59`));

            const baseRef = collection(db, servicetablename, select_company_uid, "voucher_print");
            const q = query(
                baseRef,
                where("receiptstatus", "==", true),
                where("date_time", ">=", startTimestamp),
                where("date_time", "<=", endTimestamp)
            );

            const snapshot = await getDocs(q);

            let total_credit_amount = 0;
            let total_debit_amount = 0;

            // Group by voucher name
            const voucherMap = new Map();

            snapshot.forEach((doc) => {
                const data = doc.data();
                const voucherName = data.voucher;
                const amount = Number(data.totalamount || 0);
                const voucherType = data.voucher_type || "receipt";

                total_credit_amount += amount;

                // Group by voucher name
                if (voucherMap.has(voucherName)) {
                    const existing = voucherMap.get(voucherName);
                    existing.total_amount += amount;
                    existing.count += 1;
                    existing.voucherids.add(data.voucherid);
                } else {
                    voucherMap.set(voucherName, {
                        voucher: voucherName,
                        voucher_type: voucherType,
                        total_amount: amount,
                        count: 1,
                        voucherids: new Set([data.voucherid])
                    });
                }
            });

            // Convert map to array and format for display
            const voucherSummaryArray = Array.from(voucherMap.values()).map(voucher => ({
                ...voucher,
                voucherids: Array.from(voucher.voucherids)
            })).sort((a, b) => b.total_amount - a.total_amount);

            setVoucherSummary(voucherSummaryArray);
            setTotalCredit(total_credit_amount);
            setTotalDebit(total_debit_amount);

            // Set data for download
            setReportsData(voucherSummaryArray);
            setAmount(total_credit_amount);
            setTransaction(snapshot.size);

            if (snapshot.size === 0) {
               // Toastshow("No transactions found for selected period", "info");
                setVoucherSummary([]);
            } else {
               // Toastshow(`Found ${snapshot.size} transactions`, "success");
            }
        } catch (error) {
            console.error("Report error:", error);
            Toastshow("Error generating report", "error");
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (!select_company_uid || !guid || !printpage) return;

        const applyQuery = query(
            collection(
                db,
                servicetablename,
                select_company_uid,
                "print_settings_account_apply"
            ),
            where("guid", "==", guid),
            where("status", "==", true),
            where("printpage", "==", printpage)
        );

        const unsubscribe = onSnapshot(
            applyQuery,
            (snapshot) => {
                if (snapshot.empty) {
                    setPrintapply(null);
                    return;
                }
                setPrintapply(snapshot.docs[0]?.data()?.printsize ?? null);
                setPrintid(snapshot.docs[0]?.data()?.printid ?? null);
            },
            (error) => {
                console.error("Print apply listener error:", error);
                setPrintapply(null);
            }
        );

        return unsubscribe;
    }, [select_company_uid, guid, printpage]);

    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, "accountingfinancedb", select_company_uid, "print_setting"), where("printid", "==", printid)
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

            const settingArray = data[0]?.settingdata || [];

            // convert back to object
            const settingObj = Object.fromEntries(
                settingArray.map(item => [item.key, item.value])
            );

            setPrintdata(settingObj);
        });

        return () => unsub();
    }, [select_company_uid, printid]);
    // Calculate grand total
    const grandTotal = voucherSummary.reduce((sum, v) => sum + v.total_amount, 0);
    const totalTransactions = voucherSummary.reduce((sum, v) => sum + v.count, 0);
    const totalUniqueIDs = voucherSummary.reduce((sum, v) => sum + v.voucherids.length, 0);

    const downloadPDF = () => {
        if (!reportsrata || reportsrata.length === 0) {
            alert("No data to generate report");
            return;
        }

        // Build table rows for voucher summary
        const tableRows = reportsrata.map((row, index) => {
            return `
            <tr>
                <td class="center">${index + 1}</td>
                <td class="fcap">${row.voucher || "N/A"}</td>
                <td class="fcap">${row.voucher_type || "N/A"}</td>
                <td class="right">₹${(row.total_amount || 0).toLocaleString()}</td>
                <td class="center">${row.count || 0}</td>
                <td class="center">${((row.total_amount / grandTotal) * 100).toFixed(1)}%</td>
                <td class="center">${row.voucherids?.length || 0}</td>
            </tr>
        `;
        }).join("");

        const content = `
        <div>
            <!-- HEADER -->
            <table classname="b-bottom">
                <tr>
                  <td>
                        <div class="title_sub">${printdata.print_title || "Receipt"}</div>
                        <div class="text-h2">${printdata.print_tagline || ""}</div>
                        <div class="text-h3">${printdata.print_contactinfo || ""}</div>
                        <div class="text-h3 bold">${printdata.print_address || ""}</div>
                   
                        </td>
                   
                    <td style="text-align:right">
                       <div class="text-h2">Report: ${from_date} to ${to_date}</div>
                    <div class="text-h2">Total Credit: <b>₹${totalCredit.toLocaleString()}/-</b></div>
                        
                        <div class="text-h2 bold p-top">Total Transactions: ${totalTransactions} | Total Amount: ₹${grandTotal.toLocaleString()}/-</div>
                        <div class="text-h3">Print Date: ${new Date().toLocaleString()}</div>
                    </td>
                </tr>
            </table>

            <!-- TITLE -->
            <div  > 
                <div class="title_sub center">POS Receipt Summary</div>
                <!-- TABLE -->
                <table class="report-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Voucher Name</th>
                            <th>Voucher Type</th>
                            <th>Total Amount</th>
                            <th>Transactions</th>
                            <th>% of Total</th>
                            <th>Unique IDs</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="bold right">Total:</td>
                            <td></td>
                            <td class="right bold">₹${grandTotal.toLocaleString()}</td>
                            <td class="center bold">${totalTransactions}</td>
                            <td class="center bold">100%</td>
                            <td class="center bold">${totalUniqueIDs}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <!-- FOOTER -->
            <div class="p-2">
                <table class="w-100">
                    <tr>
                        <td class="bold text-h2">Generated by: Aooz.in</td>
                        <td class="text-h2 bold" style="text-align: right">Total Credit: ₹${totalCredit.toLocaleString()}</td>
                    </tr>
                </table>
            </div>
        </div>
    `;
        const firstVoucherName =  "POS Receipt Summary";
        const sanitizedVoucherName = firstVoucherName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const fileName = `${sanitizedVoucherName}_${from_date}_to_${to_date}.pdf`;
        // Open a new window and write the content for printing
        const printWindow = window.open("", "", "width=1200,height=800");
        printWindow.document.write(`
        <html>
        <head>
            <title>Voucher Summary Report</title>
            <style>
                @page {
                    size: A4 portrait;
                    margin: 10mm;
                }

                body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 20px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    page-break-inside: auto;
                }

                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }

                tr { page-break-inside: avoid; }

                .report-table th,
                .report-table td {
                    border: 1px solid #ccc;
                    padding: 8px;
                    font-size: 12px;
                    word-break: break-word;
                }

                .report-table thead tr {
                    background: #f0f0f0;
                    font-weight: bold;
                }

                .report-table tfoot tr {
                    background: #f5f5f5;
                    font-weight: bold;
                }

                .bold { font-weight: bold; }
                .center { text-align: center; }
                .right { text-align: right; }
                .fcap { text-transform: capitalize; }
                .left { text-align: left; }

                .title_sub { font-size: 18px; font-weight: bold; margin-bottom: 10px; }
                .text-h2 { font-size: 12px; }
                .text-h3 { font-size: 10px; }
                .text-h4 { font-size: 9px; }

                .items-back-fill {
                    border: 1px solid #ddd;
                    margin: 15px 0;
                    padding: 10px;
                }

                .p-top { margin-top: 10px; }
                .p-2 { padding: 15px; }
                .w-100 { width: 100%; }
                
                table td {
                    vertical-align: top;
                }
            </style>
        </head>
        <body>${content}</body>
        </html>
    `);

        printWindow.document.close();
        // Set the document title for the print window
        printWindow.document.title = fileName;
        printWindow.print();
    };

    return (
        <div>
            <div className="items-back">

                {/* Header */}
                <div className="b-bottom">
                    <table className="w-100">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2">
                                        <HiOutlineDocumentReport className="icon" />POS Receipt Summary
                                    </div>
                                </td>
                                <td width={30}>
                                    <div className="button-ui0 p-2 cursor">
                                        <MdClose onClick={() => navigate(-1)} className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Main content */}
                <div className="container_size_info p-2">

                    {/* Date range and search */}
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td width={300}>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={30}>
                                                        <TbReport className="icon" />
                                                    </td>
                                                    <td>
                                                        <input
                                                            value={from_date}
                                                            type="date"
                                                            onChange={(e) => setFrom_date(e.target.value)}
                                                            placeholder="From Date"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            value={to_date}
                                                            type="date"
                                                            onChange={(e) => setTo_date(e.target.value)}
                                                            placeholder="To Date"
                                                        />
                                                    </td>
                                                    <td>
                                                        <div
                                                            onClick={get_voucher_summary}
                                                            className="button-ui cursor p-1"
                                                            style={{ marginLeft: '10px' }}
                                                        >
                                                            <MdSearch className="icon" /> Search
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td></td>
                                    <td width={120}>
                                        <div
                                            className="button-ui2 p-1 cursor"
                                            title="Download PDF"
                                            onClick={downloadPDF}
                                        >
                                            <MdFileDownload className="icon cursor" />PDF Download
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Voucher Summary Section */}
                    {summarysearch && !isLoading && voucherSummary.length > 0 && (
                        <div>
                            {/* Credit/Debit Summary */}
                            {summarysearch && !isLoading && voucherSummary.length > 0 && (
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="bold text-h1">POS Receipt Summary</div>
                                            </td>
                                            <td>
                                                <div className="bold text-h1 text-r">Total Credit ₹{totalCredit.toLocaleString()}/-</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                            <div className="b-1 m-1 p-11 rounded">
                                <div className="p-1">
                                    <table>
                                        <thead className="b-bottom">
                                            <tr>
                                                <th className="p-1 text-left">#</th>
                                                <th className="p-1 text-left">Voucher Name</th>
                                                <th className="p-1 text-left">Voucher Type</th>
                                                <th className="p-1 text-right">Total Amount</th>
                                                <th className="p-1 text-center">Transactions</th>
                                                <th className="p-1 text-center">% of Total</th>
                                                <th className="p-1 text-center">Unique IDs</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {voucherSummary.map((voucher, idx) => (
                                                <tr key={voucher.voucher} className={idx % 2 === 0 ? 'bg-light' : ''}>
                                                    <td>{idx + 1}</td>
                                                    <td className="p-1 fcap">
                                                        <strong>{voucher.voucher}</strong>
                                                    </td>
                                                    <td className="p-1 fcap">{voucher.voucher_type}</td>
                                                    <td className="p-1 text-right bold">
                                                        ₹{voucher.total_amount.toLocaleString()}
                                                    </td>
                                                    <td className="p-1 text-center">{voucher.count}</td>
                                                    <td className="p-1 text-center">
                                                        {((voucher.total_amount / grandTotal) * 100).toFixed(1)}%
                                                    </td>
                                                    <td className="p-1 text-center">
                                                        <span className="badge">
                                                            {voucher.voucherids.length}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="b-top">
                                            <tr>
                                                <td colSpan="2" className="p-1 bold">Total</td>
                                                <td></td>
                                                <td className="p-1 text-right bold">
                                                    ₹{grandTotal.toLocaleString()}
                                                </td>
                                                <td className="p-1 text-center bold">
                                                    {totalTransactions}
                                                </td>
                                                <td className="p-1 text-center bold">100%</td>
                                                <td className="p-1 text-center bold">
                                                    {totalUniqueIDs}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Loading indicator */}
                    {isLoading && (
                        <div className="post-container">
                            <div className="text-center p-2">
                                Loading report data...
                            </div>
                        </div>
                    )}

                    {/* No data message */}
                    {summarysearch && !isLoading && voucherSummary.length === 0 && (
                        <div className="post-container">
                            <div className="text-center p-2">
                                No transactions found for selected date range
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}